import React from 'react';
import classNames from 'classnames/bind';
import styles from './PatientManagementFormSkeleton.module.scss';

const fieldPlaceholders = Array.from({ length: 5 }, (_, index) => index);
const cn = classNames.bind(styles);

const PatientManagementFormSkeleton = () => (
  <div className={cn('patient-management-form-skeleton')}>
    <div className={cn('patient-management-form-skeleton__header')}>
      <div className={cn('patient-management-form-skeleton__header-actions')}>
        <div className={cn('patient-management-form-skeleton__block')} />
        <div className={cn('patient-management-form-skeleton__block')} />
      </div>
    </div>

    <div className={cn('patient-management-form-skeleton__form-container')}>
      {fieldPlaceholders.map(field => (
        <div className={cn('patient-management-form-skeleton__input-field-column')} key={field}>
          <div className={cn('patient-management-form-skeleton__label')} />
          <div className={cn('patient-management-form-skeleton__input')} />
        </div>
      ))}
    </div>

    <div className={cn('patient-management-form-skeleton__footer')}>
      <div className={cn('patient-management-form-skeleton__button')} />
    </div>
  </div>
);

export default PatientManagementFormSkeleton;
